import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { PatientType } from 'src/app/core/constants/KRollConstants';
import { UserService } from 'src/app/core/services/api-services/user.service';
import { createTextMaskInputElement } from 'text-mask-core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { Location } from '@angular/common';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import * as moment from 'moment';
import { MatCheckboxChange } from '@angular/material/checkbox';
export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'YYYY-MM-DD',
  },
  display: {
    dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@Component({
  selector: 'app-quick-add-user-ring',
  templateUrl: './quick-add-user-ring.component.html',
  styleUrl: './quick-add-user-ring.component.scss',
  providers: [{ provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS }],
})
export class QuickAddUserRingComponent implements OnInit {
  progress_spinner: boolean = false;
  isEditing: boolean = false;
  routeSubscription: Subscription = new Subscription();
  createPromoForm: FormGroup | any;
  dataFound: boolean = true;
  phoneMask = [
    '+',
    '1',
    ' ',
    '(',
    /[1-9]/,
    /\d/,
    /\d/,
    ')',
    ' ',
    /\d/,
    /\d/,
    /\d/,
    '-',
    /\d/,
    /\d/,
    /\d/,
    /\d/,
  ];
  PatientType = PatientType;
  selectedUsers: any[] = [];
  searchForm: FormGroup = new FormGroup({});
  allStateList: any[] = [];
  allTimeZoneList: any[] = [];
  usereditData: any[] = [];
  dob: Date | null = null;
  status: any[] = [];
  tenant: any = localStorage.getItem('tenant');
  holdno: any;
  //disable: string = ''; // or disable: string = '0'; if you want to initialize it with '0'
  //consent: string = ''; // or consent: string = '0'; if you want to initialize it with '0'
  constructor(
    public dialog: MatDialog,
    public userService: UserService,
    public fb: FormBuilder,
    public toastr: ToastrService,
    public location: Location,
    public dialogRef: MatDialogRef<QuickAddUserRingComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: any,
  ) { }

  ngOnInit() {
    this.initializeForm();
    this.stateList();
  }

  addEvent(type: string, event: MatDatepickerInputEvent<Date>) {
    console.log('Event:', type, event);
  }

  onDisableChange(event: MatCheckboxChange): void {
    this.createPromoForm.get('disable').setValue(event.checked ? 1 : 0);
  }

  onConsentChange(event: MatCheckboxChange): void {
    this.createPromoForm.get('consent').setValue(event.checked ? 1 : 0);
  }

  applyPhoneMask(event: any): void {
    const input = event.target;
    const maskInput = createTextMaskInputElement({
      inputElement: input,
      mask: this.phoneMask,
      guide: false,
    });
    maskInput.update();
  }

  testPhoneData(ve: any) {
    this.holdno = ve.target.value;
  }

  onDateChange(event: any) {
    const formattedDate = moment(event.value).format('YYYY-MM-DD');
    this.createPromoForm.get('dob').setValue(formattedDate);
  }

  getCurrentDate(): string {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = ('0' + (currentDate.getMonth() + 1)).slice(-2);
    const day = ('0' + currentDate.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  }

  initializeForm(data?: any) {
    try {
      this.createPromoForm = this.fb.group(
        {
          firstName: new FormControl('', Validators.compose([Validators.required])),
          lastName: new FormControl('', Validators.compose([Validators.required])),
          email: new FormControl(''),
          phone: new FormControl('', Validators.compose([Validators.required])),
          dob: new FormControl('', Validators.compose([Validators.required])),
          timezone: new FormControl('', Validators.compose([Validators.required])),
          kroll_id: new FormControl(''),
          state_id: new FormControl(''),
          password: new FormControl('', Validators.compose([Validators.required])),
          password_confirm: new FormControl('', Validators.compose([Validators.required])),
          referral_code: new FormControl(''),
          shipping_address: new FormControl(''),
          shipping_address_detail: new FormControl(''),
          postal_code: new FormControl(''),
          user_state_id: new FormControl(''),
          prescription_id: new FormControl(this.data?.item?.rowId || ''),
          source_from: new FormControl('rc_fax')
        },
        { validator: this.passwordMatchValidator }, // Add custom validator
      );
    } catch (error) {
      console.error('Error initializing form:', error);
    }
  }

  passwordMatchValidator(group: FormGroup) {
    const password = group.get('password')?.value;
    const confirmPassword = group.get('password_confirm')?.value;
    if (confirmPassword != '') {
      return password == confirmPassword ? null : { mismatch: true };
    }
    return null;
  }

  save() {
    if (this.createPromoForm.valid) {
      const payload: { dob?: string | moment.Moment;[key: string]: any } = {
        ...this.createPromoForm.value,
      };
      if (payload.dob instanceof moment) {
        payload.dob = (payload.dob as moment.Moment).format('YYYY-MM-DD');
      }
      if (payload.phone) {
        payload.phone = this.holdno.replace(/[^\d]/g, '');
      }
      this.isEditing = true;
      this.userService.userAdd(payload).subscribe(
        (res: any) => {
          if (res.body.success) {
            this.toastr.success(res.body.message);
            this.dialogRef.close(true);
          } else {
            this.toastr.error(res?.body?.message);
          }
          this.isEditing = false;
        },
        (err) => {
          this.isEditing = false;
          this.toastr.error(err.message);
          this.dialogRef.close(false);
        }
      );
    } else {
      this.isEditing = false;
      this.toastr.error('Please fill all required fields', 'Error');
      this.dialogRef.close(false);
    }
  }
  stateList() {
    let payload = {};
    this.userService.stateList(payload).subscribe((res) => {
      if (res?.body?.success) {
        this.allStateList = res?.body?.data;

        this.allTimeZoneList = this.allStateList.filter(
          (item) => item?.timezone !== null && item?.timezone !== undefined
        );
      } else {
        this.allStateList = [];
        this.allTimeZoneList = [];
      }
    });
  }

  userStateId(parentId: any) {
    if (parentId && parentId > 0) {
      const stateIdControl = this.createPromoForm.get('state_id');
      stateIdControl.setValue(parentId);
    }
  }

  goBack() {
    this.location.back();
  }
}
